import React from 'react';
import ReactDOM from 'react-dom';
import AppWrapper from './AppWrapper';
import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';

import './styles.css'
import 'bootstrap/dist/css/bootstrap.min.css'


const BaseApp = () => {
    return (
        <BrowserRouter>
            <CookiesProvider>
                <AppWrapper />
            </CookiesProvider>
        </BrowserRouter>
    );
};

ReactDOM.render(
    <BaseApp />
    , document.getElementById('root'),
);